import { css, styled } from "styled-components";
import { Typography } from "antd";


const ContentObjectiveStyled = styled.div<{ $disabledMission : boolean}>`
  display: flex;
  padding: 16px 24px; 
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  flex-grow: 1;

  ${({ $disabledMission }) =>{
    return  $disabledMission && css`
      filter: grayscale(100%);
      opacity: 0.7;
      `
  }}
`;

const ContentTitleStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const TitleStyled = styled(Typography)<{ $completed: boolean }>`
  color: ${({ theme }) => theme?.colors?.text?.headings};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */

  span {
    color: ${({ theme }) => theme?.colors?.theme?.brandColor3};
  }
  ${({ $completed }) => $completed && css`
    color: ${({ theme }) => theme?.colors?.common?.green};
    span {
      color: ${({ theme }) => theme?.colors?.common?.green};
    }
  `}
`;

export { ContentObjectiveStyled, TitleStyled, ContentTitleStyled };
